import {FormControl, FormHelperText, Input, InputLabel} from "@material-ui/core"
import React from "react"

/**
 * Input that handles the specification of a person's email.
 *
 * @param email: {String} The currently selected email.
 * @param emailError: {String} The current email error (if any).
 * @param classes: {Object} Contains the JSS classes to configure the visuals of the input.
 * @param label: {String} The string to use when labeling the input.
 * @param changeEmail: {Function} A function to execute when the value has changed somehow.
 */
const EmailInput = ({
                                 email,
                                 emailError,
                                 classes = {},
                                 label = "Email",
                                 tabIndex = 4,
                                 changeEmail = (event, shouldValidate) => null,
                             }) => (

    <FormControl className={classes.formControl}
                 fullWidth={true} error={email !== null && emailError !== ""}
                 aria-describedby="emailError">
        <InputLabel htmlFor="email">{label}</InputLabel>

        <Input id="email"
              onChange={event => changeEmail(event, false)}
              onBlur={event => changeEmail(event, true)}
              inputProps={{
                   autoComplete: 'off',
                   spellCheck: "false",
                   tabIndex
               }}
               value={email}/>

        <FormHelperText id="emailError">{emailError}</FormHelperText>
    </FormControl>

)

export default EmailInput
